<template>
    <div>
        <div class="email">
            <label class="font-14" :class="required ? 'required': ''"><i class="icon-email"/> {{ t('GENERAL.EMAIL') }}:
            </label>
            <button data-cy="user_index_add_phone" class="btn btn-primary" type="button" data-target="#addNew"
                    data-toggle="modal" @click="startAdd()" v-if="!isView">
                <i class="icon-plus"/>
            </button>
        </div>
        <div class="row gutters">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                <div class="table">
                    <div class="row gutters pd-10 contact-table-header" v-if="!widthPhone()">
                        <div class="custom-th col-xl-5 col-lg-4 col-md-4" :class="customClass(1, false, true)">
                            {{ t('COMPANY.EMAIL') }}
                        </div>
                        <div class="custom-th col-xl-5 col-lg-5 col-md-5" :class="customClass(2, false, true)">
                            {{ t('GENERAL.COMMENT') }}
                        </div>
                        <div class="custom-th col-xl-2 col-lg-2 col-md-2" v-if="!isView"
                             :class="customClass(3, false, true)">
                            {{ t('ACTIONS.LABEL') }}
                        </div>
                    </div>
                    <div v-if="!widthPhone() && (emails && emails[0])">
                        <div class="row gutters2" v-for="(email, key) in emails" :key="email.id">
                            <div class="custom-td td-email bt" :class="customClass(1, key)">{{
                                    email.email
                                }}
                            </div>
                            <div class="custom-td td-email bt" :class="customClass(2, key)">{{
                                    email.description
                                }}
                            </div>
                            <div class="custom-td td-email bt br-0" :class="customClass(3, key)" v-if="!isView">
                                <button data-cy="user_index_phone_update" class="btn btn-primary mr-2 mb-1"
                                        type="button"
                                        @click="edit(email, key)"><i class="icon-edit"/></button>
                                <button data-cy="user_index_phone_delete" class="btn btn-primary mb-1" type="button"
                                        @click="deleteEmail(key, email)"><i class="icon-delete"/></button>
                            </div>
                        </div>
                    </div>
                    <div v-if="widthPhone() && (emails && emails[0])">
                        <div class="bt2"></div>
                        <div class="gutters2 text-left" v-for="(email, key) in emails" :key="email.id">
                            <div class="row gutters ml-2">
                                <div class="col-sm-6 col-6" style="padding-top: 0.5rem;">
                                    <b class="mt-2">{{ t('GENERAL.PHONE_TYPE') }}</b>
                                </div>
                                <div class="col-sm-6 col-6" style="padding-top: 0.5rem;">
                                    <b>{{ t('COMPANIES.NUMBER') }}</b>
                                </div>
                            </div>
                            <div class="row gutters mt-2 ml-2">
                                <div class="col-sm-6 col-6" v-if="types">
                                    {{ types.find(t => t.id == email.type).text }}
                                </div>
                                <div class="col-sm-6 col-6">
                                    {{ email.email }}
                                </div>
                            </div>
                            <div class="row gutters mt-4 ml-2">
                                <div class="col-sm-12 col-12">
                                    <b>{{ t('GENERAL.COMMENT') }}</b>
                                </div>
                            </div>
                            <div class="row gutters mt-2 ml-2 mr-2 text-justify">
                                <div class="col-sm-12 col-12">
                                    {{ email.description }}
                                </div>
                            </div>
                            <div class="text-center" v-if="!isView">
                                <a type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                   style="font-size: 20px">
                                    <i class="icon-more_horiz"></i>
                                </a>
                                <div
                                        class="dropdown-menu  dropdown-menu2 dropdown-menu-phone dropdown-black dropdown-menu-custom">
                                    <div data-cy="user_index_phone_update" @click="edit(email, key)"
                                         class="dropdown-item bg-hover-black pointer text-white">
                                        <i class="icon-edit"/> {{ t('ACTIONS.UPDATE') }}
                                    </div>
                                    <div data-cy="user_index_phone_delete" @click="deleteEmail(key, email)"
                                         class="dropdown-item bg-hover-black pointer text-white">
                                        <i class="icon-delete"/> {{ t('ACTIONS.DELETE') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!emails || emails && !emails[0]">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center p-0">
                            <div class="card">
                                <div class="card-body">Nenhum E-mail Cadastrado</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="firstModal == 'true'" class="validation text-left">
                    {{ t('GENERAL.MSG.PLEASE_ADD_A_PHONE_TO_GO_AFTER') }}
                </div>
            </div>
        </div>

        <transition name="fade">
            <div class="modal-mask" v-if="add">
                <div class="modal-wrapper" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog" role="document" style="margin-top: 0rem;">
                        <div class="modal-content">
                            <div class="modal-header modal-header-color">
                                <h4 class="modal-title">{{ t('GENERAL.EMAIL') }}</h4>
                                <button type="button" class="closeX" id="closeX" @click="cancel()">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-open">
                                <div class="modal-body modal-row2" style="max-height: calc(100vh - 200px)">
                                    <div class="row gutters">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label for="email" class="required">{{ t('COMPANY.EMAIL') }}: </label>
                                                <input data-cy="profile_update_modal_phone" type="tel" id="email"
                                                       name="email"
                                                       class="form-control" placeholder="E-mail"
                                                       v-model="email"
                                                       @keypress="saveWithEnter($event)">
                                                <div class="validation" id="invalidphone" v-if="msgEmail">{{
                                                        t(msgEmail)
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row gutters">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label>{{ t("GENERAL.COMMENT") }}: </label>
                                                <textarea class="mt-1" style="width: 100%; height: 150px;"
                                                          v-model="description"
                                                          maxlength="200"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer justify-content-center">
                                <button class="btn btn-secondary mr-4" type="button" @click="cancel()">{{
                                        t("ACTIONS.CLOSE")
                                    }}
                                </button>
                                <button data-cy="user_index_add_phone_save" class="btn btn-primary" type="button"
                                        @click="createPhone()">{{ t("ACTIONS.SAVE") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

import {useI18n} from "vue-i18n";
import {useToast} from "vue-toastification";
import Validate from '@/components/validate.vue';

export default {
    name: 'email',
    mixins: [Validate],
    emits:['update','delete'],
    props: {
        emailsIndex: {
            type: [Array,Object],
            defaut: [],
        },
        isView: {
            type: Boolean,
            defaut: false,
        },
        required: {
            type: Boolean,
            defaut: false,
        },
        isPublic: {
            type: Boolean,
            defaut: false,
        }
    },

    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },

    data() {
        return {
            add: false,
            type: null,
            id: null,
            emails: [],
            types: null,
            email: null,
            isEdit: false,
            position: null,
            firstPhone: null,
            description: null,
            firstModal: localStorage.getItem('firstProfileClosed'),
        }
    },

    watch: {
        emailsIndex: function () {
            this.add = false;
            this.type = null;
            this.email = null;
            this.position = null;
            this.description = null;
            this.emails = this.emailsIndex ? this.emailsIndex : [];
            this.firstPhone = localStorage.getItem('firstProfileClosed');
        },
    },

    created() {
        this.emails = this.emailsIndex ? this.emailsIndex : [];
    },

    methods: {
        startAdd() {
            this.add = true;
            this.type = null;
            this.email = null;
            this.isEdit = false;
            this.position = null;
            this.description = null;
        },

        edit(email, key) {
            this.add = true;
            this.isEdit = true;
            this.position = key;
            this.type = email.type;
            this.id = email.id;
            this.email = email.email;
            this.description = email.description;
        },

        validateEmail() {
            let valid = true;
            if (this.email == null) {
                valid = false;
                this.msgEmail = "GENERAL.MSG.REQUIRED_FIELD";
            } else {
                valid = true;
                this.msgEmail = null;
            }
            return valid;
        },

        createPhone() {
            this.invalid = [];
            if (!this.validateEmail()) {
                return;
            }

            if (this.invalid.length == 0) {
                if (this.isEdit) {
                    this.emails.splice(this.position, 1);
                }

                this.add = false;

                if (this.id) {
                    this.emails.push(
                            {
                                id: this.id,
                                email: this.email,
                                description: this.description
                            }
                    );
                } else {
                    this.emails.push(
                            {
                                email: this.email,
                                description: this.description
                            }
                    );
                }

                this.$emit('update', this.emails);
            }
        },

        deleteEmail(key, email) {
            this.emails.splice(key, 1);
            this.$emit('delete', email);
        },

        inputValid(input, id) {
            document.getElementById(id).classList.remove("is-valid");
            document.getElementById(id).classList.remove("is-invalid");
            this.validate(input, id);
        },

        validate(input, id) {
            if (input && (input.length == 14 || input.length == 15)) {
                document.getElementById(id).classList.add("is-valid");
                return true;
            } else {
                document.getElementById(id).classList.add("is-invalid");
                return false;
            }
        },

        saveWithEnter(log) {
            if (log.key == 'Enter') {
                this.createPhone();
            }
        },

        customClass(value, key, isThead = false) {
            let col = '';
            let color = '';

            if (isThead) {
                color = '';
            } else
                color = key % 2 != 0 ? 'contact-table-row-alt' : 'table-grey';

            switch (value) {
                case 0:
                    col = !this.isView ? ' col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6' : ' col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6';
                    return color + col;
                case 1:
                    col = !this.isView ? ' col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5' : ' col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6';
                    return color + col;
                case 2:
                    col = !this.isView ? ' col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5' : ' col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6';
                    return color + col;
                case 3:
                    col = ' col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2';
                    return color + col;
            }
        },

        cancel() {
            this.add = false;
        }
    }
}
</script>

<style>
.dropdown-menu2 {
    width: 31% !important;
    left: -11px !important;
    min-width: 31% !important;
}

.item-custom {
    padding-top: 6px;
    background: transparent;
    padding-bottom: 2px;
}

.font-14 {
    font-size: 14px;
}

.red {
    color: red;
}

.btn-dropdown {
    border-radius: 50%;
    padding: 0.2rem 0.5rem;
}

.num-dropdown {
    color: white;
    font-size: 15px;
}

.email {
    display: flex;
    padding-top: 1%;
    padding-bottom: 1%;
    align-items: center;
    justify-content: space-between;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */
{
    opacity: 0;
}

.hide-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.table-white,
.contact-table-row-alt {
    background-color: transparent !important;
}

.bb {
    border-bottom: 2px solid #d9dee4 !important;
}

.contact-table-header {
    background-color: transparent !important;
    border-bottom: 2px solid #d9dee4;
}

.td-email {
    padding-top: 1rem;
}

.pd-1 {
    padding: 1rem;
}

@media screen and (min-width: 771px) {
    .max-width-type {
        max-width: 24.6%;
    }

    .min-width-number {
        min-width: 17%;
    }
}
</style>
